var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    position: 'absolute',
    bottom: '-700px',
    left: 'calc(50% - 258px)',
    width: '530px',
    height: '108px',
    fontSize: '22px',
    color: 'rgba(255, 255, 255, 0.9)',
    fontFamily: 'PingFang SC',
  })},[_c('div',{style:({
      position: 'absolute',
      top: 'calc(50% - 49px)',
      left: 'calc(50% - 265px)',
      borderRadius: '21px',
      backgroundColor: 'rgba(5, 24, 33, 0.9)',
      backdropFilter: 'blur(13.4px)',
      width: '530px',
      height: '98px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '12px 32px',
      boxSizing: 'border-box',
      gap: '28px',
    })},[_c('div',{style:({
        flex: '1',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
      })},[_c('div',{style:({
          borderRadius: '12px',
          backgroundColor: 'rgba(40, 252, 246, 0.02)',
          boxShadow: '0px 0px 14.1px rgba(48, 198, 201, 0.3) inset',
          width: '72px',
          height: '72px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        })},[_c('img',{style:({
            position: 'relative',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }),attrs:{"alt":"","src":require("@/assets/images/photovoltaic/wang.png")}})]),_c('div',{style:({
          flex: '1',
          borderRadius: '4px',
          display: 'flex',
          fontSize: '16px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          gap: '14px',
        })},[_c('div',{style:({ position: 'relative', lineHeight: '30px' })},[_vm._v("养护里程（km）")]),_c('div',{style:({
            position: 'relative',
            fontSize: '28px',
            lineHeight: '18px',
            fontFamily: 'Eurostile LT Std',
            color: '#c0fbf8',
          })},[_vm._v("\n          15115\n          ")])])]),_c('div',{style:({
        flex: '1',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
      })},[_c('div',{style:({
          borderRadius: '12px',
          backgroundColor: 'rgba(40, 252, 246, 0.02)',
          boxShadow: '0px 0px 14.1px rgba(48, 198, 201, 0.3) inset',
          width: '72px',
          height: '72px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        })},[_c('img',{style:({
            position: 'relative',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }),attrs:{"alt":"","src":require("@/assets/images/photovoltaic/qian.png")}})]),_c('div',{style:({
          flex: '1',
          borderRadius: '4px',
          display: 'flex',
          fontSize: '16px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          gap: '16px',
        })},[_c('div',{style:({ position: 'relative', lineHeight: '30px' })},[_vm._v("\n          节约成本（万元）\n        ")]),_c('div',{style:({
            position: 'relative',
            fontSize: '28px',
            lineHeight: '18px',
            fontFamily: 'Eurostile LT Std',
            color: '#c0fbf8',
          })},[_vm._v("\n          451\n          ")])])])]),_c('img',{style:({
      position: 'absolute',
      top: 'calc(50% - 54px)',
      left: '0px',
      width: '26px',
      height: '108px',
      objectFit: 'cover',
    }),attrs:{"alt":"","src":"https://sass.gclme.com/api/file/Image/annex/20231228_36c7048fa003472098341fd32ef1a1c2.png"}}),_c('img',{style:({
      position: 'absolute',
      top: 'calc(50% - 54px)',
      right: '0px',
      width: '26px',
      height: '108px',
      objectFit: 'cover',
    }),attrs:{"alt":"","src":"https://sass.gclme.com/api/file/Image/annex/20231228_82d3a67c92614ceab706f7d083afe831.png"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }